import { useQuery } from "react-query";
import CategoryService from "../../services/categoryService";

export const useCateQuery = (productType: TProductType | null,cityId: number | null) => {
  return useQuery<LocationDTO[]>(
    ["cate", productType],
    () => CategoryService.getCategories(productType,cityId),
    { keepPreviousData: true, refetchOnWindowFocus: false },
  );
};
